import { createMoney } from '../../../data/shared/money';
import moment from 'moment';
import * as serviceTypes from "../constants/service_types";
import {equals as bagTransportEquals} from "./bag_transport_form";
import {equals as bikeTransportEquals} from "./bike_transport_form";
import {equals as carTransportEquals} from "./car_transport_form";
import {equals as carParkingEquals} from "./car_parking_form";
import {equals as peopleTransportEquals} from "./people_transport_form";
import {equals as regularShuttleEquals} from "./regular_shuttle_form";

const getServiceItemPrice = (price) => {
    if (null == price) {
        return null;
    }

    return (price.amount / 100).toFixed(2)
};

const getServiceItemTotal = (price, quantity) => {
    if (null == price || null == quantity) {
        return createMoney({
            amount: 0,
            currency: 'EUR'
        });
    }

    return createMoney({
        amount: (price.amount * quantity).toFixed(2),
        currency: price.currency
    });
};

const getIntegerAsString = (value) => {
    return null == value ? null : value.toString();
};

const getFloatAsString = (value) => {
    return null == value ? null : parseFloat(value).toFixed(2);
};

const getDateAsMoment = (date) => {
    return moment(date);
};

const equals = (type, itemA, itemB)=> {
    switch (type) {
        case serviceTypes.BAG_TRANSPORT :
            return bagTransportEquals(itemA, itemB);
        case serviceTypes.BIKE_TRANSPORT :
            return bikeTransportEquals(itemA, itemB);
        case serviceTypes.CAR_PARKING :
            return carParkingEquals(itemA, itemB);
        case serviceTypes.CAR_TRANSPORT :
            return carTransportEquals(itemA, itemB);
        case serviceTypes.PEOPLE_TRANSPORT :
            return peopleTransportEquals(itemA, itemB);
        case serviceTypes.REGULAR_SHUTTLE :
            return regularShuttleEquals(itemA, itemB);
    }
}

export {
    getServiceItemPrice,
    getServiceItemTotal,
    getIntegerAsString,
    getDateAsMoment,
    getFloatAsString,
    equals
};
